import React, { useEffect, useMemo, useState, useRef, useCallback } from 'react';
import { Container, Row, Col, Form } from "react-bootstrap";
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import * as AuthVerify from '../../lib/common';
import MaterialReactTable from 'material-react-table';
import { Input,Cascader } from 'antd';
import {
    Box,
    Button,
    IconButton,
    Typography,
    Tooltip,
} from '@mui/material';
import Axios from '../../lib/axios/axiosInstance';
import Modal from 'react-bootstrap/Modal';
import { Slide, toast } from 'react-toastify';
import { Delete, Print, Download, List } from '@mui/icons-material';
import Loader from '../Common/loader';
import { createTheme, ThemeProvider, useTheme } from '@mui/material';

const TemplateDetails = () => {
    const navigate = useNavigate();
    
    const [templateName, setTemplateName] = useState('');
    const [templateCC, setTemplateCC] = useState(false);
    const [templateC, setTemplateC] = useState(false);
    const [templateRemarks, setTemplateRemarks] = useState('');
    const [templateSharedCC, setTemplateSharedCC] = useState(false);


    const [searchParams, setSearchParams] = useSearchParams();
    const [ccnum, setCcnum] = useState("");
    const [cnum, setCnum] = useState("");
    const [emShow, setEmShow] = useState(false);
    const [costCenterDetails, setCostCenterDetails] = useState(false);
    const [ccList, setccList] = useState([]);
    const [cList, setcList] = useState([]);
    const [cListFiltered, setcListFiltered] = useState([])
    const [templateNum, setTemplateNum] = useState(false);
    const [templateDetails, setTemplateDetails] = useState({items:[]});

    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isRefetching, setIsRefetching] = useState(false);
    const [eData, setEData] = useState([]);
    const [eRowCount, setERowCount] = useState(0);
    const [eColumnFilters, setEColumnFilters] = useState([]); const [eColumnFilterFns, setEColumnFilterFns] = useState({
        matname: 'contains',
        sellingprice: 'equals',
        contractprice: 'equals',
        contractno: 'contains',
        startdate: 'contains',
        enddate: 'contains'
    });
    const [eGlobalFilter, setEGlobalFilter] = useState('');
    const [eSorting, setESorting] = useState([]);
    const eTableInstanceRef = useRef(null);
    const [ePagination, setEPagination] = useState({
        pageIndex: 0,
        pageSize: 10
    });

    const columns = useMemo(
        () => [
            {
                accessorFn: (row) => row.imageurl,
                id: 'imageurl',
                enableColumnFilter: false,
                enableSorting: false,
                enableColumnFilterModes: false,
                header: 'Product',
                enableEditing: false,
                size: 50,
                Cell: ({ cell, row }) => (
                    <a href="#">
                        <img style={{ maxHeight: "60px" }} src={AuthVerify.getImageLink(cell.getValue())} alt="Product" />
                    </a>
                    // <Typography variant='h7'>{cell.getValue()}</Typography>
                ),
                filterFn: 'contains',
                columnFilterModeOptions: ['contains'],
            },
            {
                accessorKey: 'matname',
                header: "Description",
                Cell: ({ cell, row }) => (
                    <>
                        <Typography variant='h7'>
                            <Link to={"/product-detail?matnum=" + cell.getValue()}>{cell.getValue()}</Link>
                        </Typography>
                        {/* <Typography variant='h7'>Matnum: {cell.getValue()}</Typography> */}
                    </>

                ),
                size: 50,
                enableColumnFilterModes: true,
                filterFn: 'contains',
                columnFilterModeOptions: ['contains'],
            },
            {
                accessorKey: 'contractprice',
                header: "Contract price",
                Cell: ({ cell, row }) => (
                    <Typography variant='h7'>{cell.getValue()}</Typography>
                ),
                size: 50,
                enableColumnFilterModes: true,
                filterFn: 'equals',
                columnFilterModeOptions: ['equals', 'lessThan', 'greaterThan'],
            },
            {
                accessorKey: 'sellingprice',
                header: "Selling Price",
                Cell: ({ cell, row }) => (
                    <Typography variant='h7'>{cell.getValue()}</Typography>
                ),
                size: 50,
                enableColumnFilterModes: true,
                filterFn: 'equals',
                columnFilterModeOptions: ['equals', 'lessThan', 'greaterThan'],
            }
            //end
        ],
        [],
    );

    const findFilterCondition = (name) => {
        var condition = '';
        if (eColumnFilterFns[name]) {
            condition = eColumnFilterFns[name];
        }
        // if(condition==''){
        //   condition = initialColumnFiltersFns[name];
        // }
        return condition;
    }

    useEffect(() => {
        if (emShow) getNewCartItemsFromList();
    }, [
        eColumnFilters,
        eGlobalFilter,
        ePagination.pageIndex,
        ePagination.pageSize,
        eSorting
    ]);

    const getNewCartItemsFromList = async (reset = false) => {
        if (!eData.length) {
            setIsLoading(true);
        } else {
            setIsRefetching(true);
        }

        let filterQuery = '';
        let sorterQuery = '';

        if (!reset) {
            if (eColumnFilters.length > 0) {
                eColumnFilters.forEach(element => {
                    filterQuery += `&filter=${element.id},${findFilterCondition(element.id)},${element.value}`;
                });
            }
            if (eSorting.length > 0) {
                eSorting.forEach(element => {
                    sorterQuery += `&sortby=${element.id}&orderby=${element.desc ? 'desc' : 'asc'}`;
                });
            }
        } else {
            setEPagination({
                pageIndex: 0,
                pageSize: 5
            });
            if (eTableInstanceRef.current) eTableInstanceRef.current.resetRowSelection();
        }

        // Get list of suggested products to add to Template
        // api/account/ordertemplate/newitem
        var body = {
            "template": {
                "ccnum": ccnum, //selected cost center
                "catalognum": cnum //selected catalog
            }
        };
        if (!templateNum)
            body = {
                "template": {
                    "ccnum": templateCC, //selected cost center
                    "catalognum": templateC //selected catalog
                }
            }
        let url = `/account/ordertemplate/newitem?limit=${ePagination.pageSize}&offset=${ePagination.pageIndex * ePagination.pageSize}${sorterQuery}${filterQuery}`;
        await Axios.post(url, body)
            .then(function (response) {
                setEmShow(true);
                setIsError(false);
                setIsLoading(false);
                setIsRefetching(false);
                if (response && response.data?.data) {
                    setEData(response.data?.data.items.items ?? []);
                    setERowCount(response.data?.data.items.count);
                }
                else {
                    toast.error(response.statusText ?? "Data fetching failed !", {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3000,
                        transition: Slide,
                    });
                }
            })
            .catch(function (error) {
                // navigate('/');
            });
    };

    const addNewItemFromList = async (rows) => {
        rows.forEach(item => {
            var data = item.original
            data.qty = 1;
            templateDetails.items.push(data);
        })
        setEmShow(false);
    };

    const loadToCart = async () => {
        // Add To Cart
        // api/account/ordertemplate/addtocart/:templatenum
        await Axios.post(`/account/ordertemplate/addtocart/${templateNum}`)
            .then(async (refnum) => {
                if (refnum?.data && refnum.data.success) {
                    toast.success('Added to Cart Successfully !', {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3000,
                        transition: Slide,
                    });
                } else {
                    toast.error(refnum.data.error, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3000,
                        transition: Slide,
                    });
                }
            });
    }
    const saveTemplate = async () => {
        var templateItem = templateDetails?templateDetails.items.map(function (item) { return { matnum: item.matnum, qty: item.qty } }):[]
        var body = false;
        if(templateNum){
            body = {
                "template": {
                    "templatenum": templateDetails.template.templatenum,
                    "templatename": templateName,
                    "remark": templateDetails.template.remark,
                    "ccnum": ccnum,
                    "catalognum": cnum,
                    "ccshared": templateDetails.template.sharedtocc
                },
                "templateitem": templateItem
            }
        }else{
            body = {
                "template": {
                    "templatenum": '',
                    "templatename": templateName,
                    "remark": templateRemarks,
                    "ccnum": templateCC,
                    "catalognum": templateC,
                    "ccshared": templateSharedCC
                },
                "templateitem": templateItem
            }
        }

        // Save Template
        // api/account/ordertemplate
        await Axios.post(`/account/ordertemplate`, body)
            .then(async (refnum) => {
                if (refnum?.data && refnum.data.success) {
                    toast.success('Template Saved Successfully !', {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3000,
                        transition: Slide,
                    });
                } else {
                    toast.error(refnum.data.error, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3000,
                        transition: Slide,
                    });
                }
            });
    }

    const setQuantity = (matnum, qty) => {
        templateDetails.items.forEach(element => {
            if (element.matnum == matnum) {
                element.qty = qty;
            }
        });
        setTemplateDetails(templateDetails);
    }

    const removeItem = (matnum) => {
        let index = templateDetails.items.findIndex(item => item.matnum == matnum);
        if (index > -1) {
            templateDetails.items.splice(index, 1)
        }

        setTemplateDetails({...templateDetails});
    }

    useEffect(async () => {
        if (searchParams.get("templatenum")) {
            setTemplateNum(searchParams.get("templatenum"));
            AuthVerify.getCartDeatils(true, searchParams.get("templatenum"), true).then(async (data) => {
                if (data?.success) {
                    if(!data.data.items){
                        data.data.items=[]
                    }
                    setTemplateDetails(data.data)
                    setTemplateName(data.data.template?.templatename)
                    setCcnum(data.data.template?.ccnum)
                    setCnum(data.data.template?.catalognum)
                } else {
                    toast.error("Data fetching failed !", {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3000,
                        transition: Slide,
                    });
                }
            });

            /* await Axios.get(`/account/costcenter`)
                .then(async (data) => {
                    if (data.data?.data) {
                        data.data.data.map((item) => {
                            if (item.active) {
                                setCcnum(item.ccnum);
                                item.catalogs.forEach(element => {
                                    if (element.active) setCnum(element.catalognum);
                                });
                            }
                        });
                    }
                }); */
        }
        else {
            await Axios.get(`/account/costcenter`)
                .then(async (data) => {
                    if (data.data?.data) {
                        setCostCenterDetails(data.data?.data);
                        var ccListNew = []
                        var cListNew = []
                        data.data.data.map((item) => {
                            ccListNew.push({label:item.ccname,value:item.ccnum});
                            item.catalogs.forEach(element => {
                                cListNew.push({label:element.catalogname,value:element.catalognum,ccnum:item.ccnum});
                            });
                        });
                        setccList(ccListNew);
                        setcList(cListNew);
                    }
                });
        }
    }, [searchParams])

    const globalTheme = useTheme(); //(optional) if you already have a theme defined in your app root, you can import here

    const theme = useMemo(
        () =>
            createTheme({
                components: {
                    MuiTooltip: {
                        styleOverrides: {
                            tooltip: {
                                fontSize: '1.1rem', //override to make tooltip font size larger
                            },
                        },
                    }
                },
            }),
        [globalTheme],
    );

    return (
        <section className="main-container col1-layout">
            <Container className="main">
                <div className="col-main">
                    <div className="shopping-cart-inner">
                        <div className="page-content">
                            <div className="page-content checkout-page">
                                <div className="box-border">
                                    <h2>Order Template</h2>
                                    {templateNum ? 
                                    <>
                                        <h5><strong>Template Name: </strong> <Input style={{margin:'0'}} placeholder="Template Name" value={templateName} onChange={(e)=>{setTemplateName(e.target.value)}}/> </h5>
                                        <h5><strong>Cost Center:</strong> {templateDetails?.template?.costcentername ?? ""} </h5>
                                        <h5><strong>Catalog:</strong> {templateDetails?.template?.catalogname ?? ""} </h5>
                                        {/* <h5><strong>Shared with cost center:</strong> <input type="checkbox" checked={templateDetails?.template?.sharedtocc} readOnly={true} /> </h5> */}
                                        <h5><strong>Remark:</strong> {templateDetails?.template?.remark} </h5>
                                    </>:
                                    <>
                                        <h5><strong>Template Name: </strong> <Input style={{margin:'0'}} placeholder="Template Name" value={templateName} onChange={(e)=>{setTemplateName(e.target.value)}}/> </h5>
                                        <h5><strong>Cost Center: </strong>  
                                            <Cascader
                                                options={ccList}
                                                value={templateCC}
                                                    onChange={(e) => { setTemplateCC(e[0]); setTemplateC(false); setcListFiltered(cList.filter((c) => c.ccnum == e[0])) }}
                                                placeholder="Select Cost Center"
                                            /> 
                                        </h5>
                                        <h5><strong>Catalog: </strong> 
                                            <Cascader
                                                options={cListFiltered}
                                                value={templateC}
                                                onChange={(e)=>{setTemplateC(e[0])}}
                                                placeholder="Select Catalog"
                                            /> 
                                        </h5>
                                        {/* <h5><strong>Shared with cost center: </strong> <input type="checkbox" onClick={()=>setTemplateSharedCC(!templateSharedCC)} checked={templateSharedCC} /> </h5> */}
                                        <h5><strong>Remark: </strong> <Input style={{margin:'0'}} placeholder="Remarks" value={templateRemarks} onChange={(e)=>{setTemplateRemarks(e.target.value)}}/> </h5>
                                    </>
                                    }
                                    <br />
                                    <div className="toolbar">
                                        <div className="row">
                                            <div className="col-md-3 col-sm-3" style={{ display: "flex" }}>
                                                <h2 style={{ fontSize: "16px", letterSpacing: "1px", marginTop: "0", textTransform: "uppercase", marginBottom: "auto", fontWeight: "700" }}>Items</h2>
                                            </div>
                                            {AuthVerify.getPermissions("MyOrderTemplate")?.edit &&
                                                <div className="col-sm-3 text-right" style={{ float: "right" }}>
                                                    <a href="#" onClick={() => getNewCartItemsFromList(true)}>+ Add New</a>
                                                </div>}
                                        </div>
                                    </div>
                                    <div className="order-detail-content table-responsive">
                                        <table className="table table-bordered jtv-cart-summary">
                                            <thead>
                                                <tr>
                                                    <th className="cart_product">Product</th>
                                                    <th>Product Code</th>
                                                    <th>Product Name</th>
                                                    <th>Qty</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            {templateDetails?.items ?
                                                <>
                                                    <tbody>
                                                        {templateDetails?.items.map((item, i) => {
                                                            return (
                                                                <tr key={i}>
                                                                    <td className="cart_product"><Link to={"/product-detail?matnum=" + item?.matnum}>
                                                                        <img src={AuthVerify.getImageLink(item.imageurl)} alt="Product" /></Link>
                                                                    </td>
                                                                    <td className="cart_description"><p className="product-name"><Link to={"/product-detail?matnum=" + item?.matnum}> {item?.matnum}</Link></p></td>
                                                                    <td><span>{item.matname}</span></td>
                                                                    <td><span><input type="number" style={{ maxWidth: "70px" }} defaultValue={item.qty} onChange={(e) => setQuantity(item?.matnum, e.target.value)} /></span></td>
                                                                    <td className="a-center last">
                                                                        <span className="nobr">
                                                                            <button className="btn btn-sm" style={{ background: 'none', border: 'none', color: 'red', fontWeight: 'bold' }} title="Exchange" type="button" onClick={() => removeItem(item.matnum)}><span>Delete</span></button>
                                                                        </span>
                                                                    </td>
                                                                </tr>)
                                                        })}
                                                    </tbody>

                                                </> :
                                                <tr>
                                                    {templateDetails.items != null ? <td colSpan="6"><Loader /></td> : <td colSpan="6" style={{ textAlign: 'center' }}>No products found !</td>}
                                                </tr>
                                            }
                                        </table>
                                    </div>
                                </div>

                                <div className="cart_navigation" style={{ marginBottom: '10px' }}>
                                    <button className="button" type="button" onClick={() => navigate('/my-account?activeKey=Templates')}><span>Back to Template Listing</span></button>
                                    {/* <button className="button btn-proceed-checkout" title="Proceed to Checkout" type="button" onClick={()=>navigate('/my-account?activeKey=Templates')}><span>Back to Template Listing</span></button> */}
                                    <button onClick={() => { loadToCart() }} className="button btn-proceed-checkout" title="Save As Template" type="button">
                                        <span>Add To Order</span>
                                    </button>
                                    <button className="button btn-proceed-checkout" title="Reorder" type="button" onClick={() => saveTemplate(true)}><span>Save Template</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Container >

            <Modal show={emShow} dialogClassName="modal-90w" animation={false} fade={false} style={{ opacity: 1 }} onHide={() => setEmShow(false)}>
                <Modal.Header closeButton={false}>
                    <Modal.Title>Add to Template</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <ThemeProvider theme={theme}>
                    <MaterialReactTable
                        columns={columns}
                        data={eData}
                        enableColumnActions={false}
                        enableGlobalFilter={false}
                        enableColumnFilterModes
                        initialState={{
                            showColumnFilters: false
                        }}
                        manualFiltering
                        manualPagination
                        manualSorting
                        onColumnFilterFnsChange={setEColumnFilterFns}
                        onColumnFiltersChange={setEColumnFilters}
                        onGlobalFilterChange={setEGlobalFilter}
                        onPaginationChange={setEPagination}
                        onSortingChange={setESorting}
                        tableInstanceRef={eTableInstanceRef}
                        rowCount={eRowCount}
                        state={{
                            eColumnFilters,
                            eColumnFilterFns,
                            eGlobalFilter,
                            isLoading,
                            ePagination,
                            showAlertBanner: isError,
                            showProgressBars: isRefetching,
                            eSorting,
                        }}
                        enableRowSelection
                        renderTopToolbarCustomActions={({ row, table }) => (
                            <Box
                                sx={{ display: 'flex', gap: '0.5rem', p: '0.5rem', flexWrap: 'wrap' }}
                            >
                                <Button
                                    disabled={
                                        !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
                                    }
                                    // onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
                                    onClick={() => addNewItemFromList(table.getSelectedRowModel().rows)}
                                    startIcon={<List />}
                                    variant="contained"
                                    color="primary"
                                >
                                    Add to my template
                                </Button>
                            </Box>
                        )}
                        positionActionsColumn="last"
                        displayColumnDefOptions={{
                            'mrt-row-actions': {
                                header: 'Action', //change header text
                            },
                        }}
                        muiTableHeadCellProps={{
                            sx: {
                                // fontWeight: 'bold',
                                fontSize: '15px',
                            },
                        }}
                        muiTableBodyCellProps={{
                            sx: {
                                fontWeight: 'bold',
                                fontSize: '12px',
                            },
                        }}
                        muiTablePaginationProps={{
                            sx: {
                                fontWeight: 'bold',
                                paddingTop: '12px',
                                fontSize: '17px',
                            },
                        }}
                        muiTableHeadCellFilterTextFieldProps={{
                            sx: {
                                fontWeight: 'bold',
                                fontSize: '17px',
                            },
                        }}
                    />
                </ThemeProvider>
                    {/* <button className="button" title="Proceed to Checkout" type="button" onClick={()=>addNewCartItemsFromList()}><span>Add to my catalog</span></button> */}
                </Modal.Body>
            </Modal>

        </section >
    )
}
export default TemplateDetails;

